import { Component } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AuthorizationService } from "src/app/services/authorization.service";
import { HttpAlertService } from "src/app/services/http-alert.service";
import { UserService } from "src/app/services/user.service";

@Component({
  selector: "app-delete-account",
  templateUrl: "./delete-account.component.html",
  styleUrls: ["./delete-account.component.scss"],
})
export class DeleteAccountComponent {
  constructor(
    private userService: UserService,
    private authorizationService: AuthorizationService,
    private httpAlertService: HttpAlertService,
    private router: Router,
    private title: Title,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.translate.get('title_delete_account').subscribe({
      next: (title) => {
        this.title.setTitle(title);
      }
    });
    
  }

  handleDeleteAccount() {
    this.userService.deleteAccount().subscribe((resp) => {
      if (resp.success) {
        this.httpAlertService.success('account_deleted');
        this.authorizationService.logout();
        this.router.navigate(['/']);
      }
    });
  }
}
